import domain from './domain';

// Reset user identity
export const resetUserIdentity = domain.createEvent('resetUserIdentity');
